import { Logo } from "../components/Logo";
import { ThemeToggle } from "../components/ThemeToggle";

const BG = "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGZpbmFuY2UlMjBtYXJrZXQlMjBjaGFydHxlbnwwfHx8fDE3ODY2NjI5NDJ8MA&ixlib=rb-4.1.0&q=85";

export function AuthShell({ children, heading, subtitle }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* left visual */}
      <div className="relative hidden lg:block border-r border-border overflow-hidden">
        <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-background/60" />
        <div className="relative h-full flex flex-col justify-between p-10">
          <Logo />
          <div>
            <h2 className="font-heading text-4xl font-black tracking-tight leading-tight">
              Private currency &amp;<br />cryptocurrency<br />market intelligence.
            </h2>
            <p className="mt-4 text-sm text-muted-foreground max-w-sm">
              Live foreign exchange rates and crypto prices, historical charts, watchlists,
              conversion and alerts — in one clean dashboard.
            </p>
            <div className="mt-8 flex gap-6 font-mono text-xs text-muted-foreground uppercase tracking-widest">
              <span>IQD · VND · VES</span>
              <span>XRP · XLM · HBAR</span>
            </div>
          </div>
        </div>
      </div>

      {/* right form */}
      <div className="flex flex-col">
        <div className="flex items-center justify-between p-5 lg:justify-end">
          <div className="lg:hidden"><Logo compact /></div>
          <ThemeToggle />
        </div>
        <div className="flex-1 flex items-center justify-center px-5 pb-10">
          <div className="w-full max-w-md">
            <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight">{heading}</h1>
            <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
